// Use tooltip and popover components everywhere
$(function (){
    $(document).tooltip({
        selector: '[data-toggle=tooltip]',
        trigger: 'hover'
    });
    $(document).popover({
        selector: '[data-toggle=popover]'
    });

    $(document).mouseup(function (e) {
        var container = $('.popover');

        if (!container.is(e.target)
            && container.has(e.target).length === 0) {
            container.popover('hide');
        }
    });
});